module.exports = __webpack_public_path__ + "static/media/work-harrys.94349c66.jpg";